import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import style from './FullWidthStatistics.module.scss';
import CountingNumbers from '../CountingNumbers';

const FullWidthStatistics = ({ title, stats, componentStyle }) => {
    let styleClass = style.defaultStyle;
    if (componentStyle === 'secondary') {
        styleClass = style.secondaryStyle;
    } else if (componentStyle === 'brand') {
        styleClass = style.brandStyle;
    }

    return (
        <div className={`${style.fullWidthStatistics} ${styleClass}`}>
            <div className={`container ${style.container}`}>
                {title && (
                    <div className={style.titleSection}>
                        <h2 className={style.title}>{title}</h2>
                    </div>
                )}

                {stats && stats.length > 0 && (
                    <div className={style.statsSection}>
                        {stats.slice(0, 6).map((stat, index) => {
                            const hasLink = stat.link && stat.link.url;
                            const content = (
                                <>
                                    <div className={style.statLabel}>
                                        {stat.disableCountingAnimation ? (
                                            <>{stat.title}</>
                                        ) : (
                                            <CountingNumbers value={stat.title} />
                                        )}
                                    </div>
                                    <div
                                        className={style.statValue}
                                        dangerouslySetInnerHTML={{ __html: stat.description }}
                                    />
                                    {hasLink && (
                                        <span className={`icon-arrow-right ${style.arrowIcon}`} />
                                    )}
                                </>
                            );

                            return hasLink ? (
                                <Link key={index} href={stat.link.url}>
                                    <a
                                        className={`${style.statItem} ${style.statLink}`}
                                        target={stat.link.target || undefined}
                                        rel={stat.link.target === '_blank' ? 'noreferrer' : undefined}
                                    >
                                        {content}
                                    </a>
                                </Link>
                            ) : (
                                <div key={index} className={style.statItem}>
                                    {content}
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
};

FullWidthStatistics.propTypes = {
    title: PropTypes.string,
    stats: PropTypes.array,
    componentStyle: PropTypes.string,
};

FullWidthStatistics.defaultProps = {
    stats: [],
    componentStyle: 'Default',
};

export default FullWidthStatistics;
